import React from 'react';

import { useSelector } from 'react-redux';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';

import { MyWalletGridContainer } from 'reaxl-wallet';

import {
    paymentsDuck,
} from '@/ducks';

import { vdpResultsDuck } from '@/ducks/vdp';

import ConnectedCalculatorContainer from './ConnectedCalculatorContainer';
import PreQualCTAContainer from './PreQualCTAContainer';

export function MyWalletContainer({
    onEmailCTAClick,
    enableCreditAppLink,
    isRightRail = false,
    config,
}) {

    const {
        accelerate: [, {
            credit_app: enableDRCreditApp,
        }],
        my_wallet: [enableMyWallet, { enableDeals }],
        nds_right_rail: [isNDSRightRailEnabled],
        remove_vdp_wallet_banner: [removeVdpWalletBanner],
    } = useFeatures(['accelerate', 'my_wallet', 'nds_right_rail', 'remove_vdp_wallet_banner']);

    const device = useDevice();
    const isLessThanMd = device?.lessThan?.md;
    const isLg = device?.is?.lg;

    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const listingId = listing?.id;
    const {
        dealerSettings: {
            accountStatus = 'INACTIVE',
        } = {},
        digitalRetailingType,
    } = listing?.paymentServices ?? {};

    const isAccelerate = digitalRetailingType === 'accelerate';

    const {
        hasUpdatedNDSCalc,
        hasUpdatedWallet,
        paymentEmphasis,
    } = useSelector(paymentsDuck.selectors.getMyWalletInteractions);
    const dealDetails = useSelector((state) => paymentsDuck?.selectors?.getTransformedDealDetails(state)) || {};

    const { displayWalletErrorMessage } = useSelector(paymentsDuck.selectors.getMyWallet) || {};

    const enableSDPCreditAppLink = enableDRCreditApp && isAccelerate;

    const hasDrDeal = Object.keys(dealDetails)?.some((dealId) => dealDetails[dealId]?.vehicle?.vin === listing?.vin && dealDetails[dealId].isAccelerate);

    const props = {
        inventoryId: listingId,
        isRow: !isLessThanMd || isRightRail,
        paymentsDuck,
        sectionComponentName: 'Section',
        sectionProps: {
            id: 'nativeDealContainer',
            isRightRail,
            className: 'padding-vertical-4 padding-vertical-md-5',
        },
        showWelcomeMessage: !hasDrDeal && accountStatus === 'ACTIVE' && !hasUpdatedNDSCalc && !hasUpdatedWallet && paymentEmphasis == null,
        uiContext: 'light',
        hideGrid: !enableMyWallet || isRightRail || removeVdpWalletBanner,
        displayWalletErrorMessage,
        showIcon: isLg && !isNDSRightRailEnabled,
        onContactOwnerClick: onEmailCTAClick,
    };

    return (
        <MyWalletGridContainer {...props}>
            <ConnectedCalculatorContainer
                onEmailCTAClick={onEmailCTAClick}
                enableCreditAppLink={enableCreditAppLink || enableSDPCreditAppLink}
                lockForm={enableDeals ? hasDrDeal : undefined}
                config={config}
            />
            {!isNDSRightRailEnabled && <PreQualCTAContainer uiContext="styled" />}
        </MyWalletGridContainer>
    );
}

export default MyWalletContainer;
